const DEFAULT_TIME = '09:00:00';

export default {
  DEFAULT_TIME,
};
